import SubMenu from "antd/lib/menu/SubMenu";
import { CloseSquare, PaperPlus } from "react-iconly";
import IntlMessages from "../../layout/components/lang/IntlMessages";

const pages = [
  {
    id: "home",
    header: "Home",
    navLink: "/home",
  },
  {
    id: "dashboard",
    header: "Dashboard",
    navLink: "/dashboard",
  },
  {
    id: "readings",
    header: "Readings",
    navLink: "/readings",
  },
  {
    header: "Settings",
    subMenu: [
      {
        id: "myprofile",
        title: "My Profile",
        navLink: "/myprofile",
      },
      {
        id: "aboutus",
        title: "About Us",
        navLink: "/myprofile",
      },
      {
        id: "changemobileno",
        title: "Change Mobile Number",
        navLink: "/changemobile",
      },
      {
        id: "privacypolicy",
        title: "Privacy Policy",
        navLink: "/myprofile",
      },
      {
        id: "termsandconditions",
        title: "Terms and Conditions",
        navLink: "/myprofile",
      },
       {
        id: "logout",
        title: "Logout",
        navLink: "/myprofile",
      }
    ]
  }
  // {
  //     header: <IntlMessages id="sidebar-pages" />,
  //     subMenu: [
  //         {
  //             id: "blank-page",
  //             title: <IntlMessages id="sidebar-pages-blank-page" />,
  //             icon: <PaperPlus set="curved" className="remix-icon" />,
  //             navLink: "/pages/blank-page",
  //         },
  //         {
  //             id: "errors",
  //             title: <IntlMessages id="sidebar-pages-error" />,
  //             icon: <CloseSquare set="curved" className="remix-icon" />,
  //             children: [
  //                 {
  //                     id: "error-page",
  //                     title: "404",
  //                     navLink: "/pages/error-page",
  //                 },
  //             ],
  //         },
  //     ]
  // }
];

export default pages